import axios from "axios";
import {
	FETCH_STORE_COUPON,
	FETCH_ONE_COUPON,
	UPDATE_STORE,
	DELETE_STORE,
	CLEAR_ONE_COUPON,
	REDEMPTION_COUPON,
	DELETE_CATEGORY,
} from "constants/ActionTypes";
import { DELETE_REDEMPTION_COUPON } from "../../constants/ActionTypes";

const ROOT_URL = "https://appvendedores.comprasdavivienda.cr/resources/ws/";

export function fetchStoreCoupons(
	{ storeId, couponState, dateFrom, dateTo },
	callback = () => {
		console.log();
	}
) {
	const ROUTINES = `getCouponsStore.php/getStoreCoupons?storeId=${storeId}&redemptionState=${couponState}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => {
			if (request.data.success == 1) {
				return request.data.result;
			} else {
				return [];
			}
		})
		.then(callback());
	return {
		type: FETCH_STORE_COUPON,
		payload: request,
	};
}

export function fetchOneCoupon(
	{ cuponId },
	callback = () => {
		console.log();
	}
) {
	const ROUTINES = `getCouponByRename.php/getCouponByCode?code=${cuponId}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => {
			if (request.data.success == 1) {
				return request.data.result;
			} else if (request.data.success == 0) {
				return [0];
			}
		})
		.then(callback());
	return {
		type: FETCH_ONE_COUPON,
		payload: request,
	};
}

export function clearOneCoupon() {
	return {
		type: CLEAR_ONE_COUPON,
	};
}

export function updateStore(
	{ id, name, email, phoneNumber },
	callback = () => console.log()
) {
	const ROUTINES = `updateStore.php/updateStoreProfile?id=${id}&name=${name}&email=${email}&phone=${phoneNumber}&state=1`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: UPDATE_STORE,
		payload: request,
	};
}

export function deleteStore(
	{ id, name, email, phoneNumber },
	callback = () => console.log()
) {
	const ROUTINES = `updateStore.php/updateStoreProfile?id=${id}&name=${name}&email=${email}&phone=${phoneNumber}&state=0`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: DELETE_STORE,
		payload: request,
	};
}

export function deleteCategory({ id }, callback = () => console.log()) {
	const ROUTINES = `deleteCategory.php/deleteCategoryProfile?id=${id}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: DELETE_CATEGORY,
		payload: request,
	};
}

export function redemptionCoupon({ id }, callback = () => console.log()) {
	const ROUTINES = `updateRedemptionCoupon.php/updateRedemptionCouponProfile?userId=${localStorage.getItem(
		"user_id"
	)}&id=${id}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: REDEMPTION_COUPON,
		payload: request,
	};
}

export function deleteRedemptionCoupon(id, callback = () => console.log()) {
	const ROUTINES = `deleteRedemptionCoupon.php/deleteRedemptionCouponProfile?id=${id}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url)
		.then((request) => request.success)
		.then(callback());
	return {
		type: DELETE_REDEMPTION_COUPON,
		payload: request,
	};
}



// WEBPACK FOOTER //
// ./src/appRedux/actions/StoreCoupons.js